import EditAuctionHouseSidePane from "./EditAuctionHouseSidePane";

export default EditAuctionHouseSidePane;
